var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('canvas',{attrs:{"id":"canvas","width":_vm.winWidth,"height":_vm.winHeight},on:{"onload":function($event){return _vm.initBg()}}}),_c('canvas',{attrs:{"id":"canvasbg","width":_vm.winWidth,"height":_vm.winHeight}})])
}
var staticRenderFns = []

export { render, staticRenderFns }